import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import classNames from 'classnames';
import { dayKeyLabel, upcomingDayKeys } from 'helpers/offerWindow';
import styles from './OfferDayChips.module.css';

// The next hours first, before today (owner, 2026-10-29); no 24 hours.
const FIXED: [string, string][] = [
  ['all', 'all_games_label'],
  ['1h', '1_hour_label'],
  ['3h', '3_hours_label'],
  ['today', 'today_label'],
  ['tomorrow', 'tomorrow_label'],
];

/** Phone: pick the part of the offer to list (?time= on the URL). */
export const OfferDayChips = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const current = params.get('time') ?? 'all';
  const days = useMemo(() => upcomingDayKeys(5), []);
  const chips: [string, string][] = [
    ...FIXED.map(([k, l]) => [k, t(l)] as [string, string]),
    ...days.map((k) => [k, dayKeyLabel(k, i18n.language)] as [string, string]),
  ];
  return (
    <div className={styles.row} role="tablist">
      {chips.map(([key, label]) => (
        <button
          key={key}
          type="button"
          role="tab"
          aria-selected={key === current}
          className={classNames(styles.chip, {
            [styles.chipOn]: key === current,
          })}
          onClick={() =>
            navigate(
              key === 'all' ? '/sports-betting' : `/sports-betting?time=${key}`
            )
          }
        >
          {label}
        </button>
      ))}
    </div>
  );
};
